import {
  AdminSpinner,
  ListSpinner,
  QueryStatus,
  agentImage,
} from '@vgrubs/components';
import { NoDataComponent } from 'components/src/adminComponents/NoDataComponent/NoDataComponent';
import { useVerificationsAgentsInfiniteScroll } from '../hooks/useVerificationsAgentsInfiniteScroll';
import { AgentComponent } from '../components/AgentComponent';

export const AgentsSection = ({ query }: { query: string }) => {
  const { agents, observerRef, isFetchingNextPage, status } =
    useVerificationsAgentsInfiniteScroll(query);

  return (
    <>
      {agents.map((agent) => (
        <AgentComponent key={agent.id} agent={agent} />
      ))}

      {agents.length === 0 &&
        status !== QueryStatus.PENDING &&
        !isFetchingNextPage && (
          <NoDataComponent
            image={agentImage}
            title="No Agents!"
            description={
              query
                ? `No agents to verify match "${query}".`
                : 'You currently do not have any agents to verify.'
            }
            height="70vh"
            heightSM="70vh"
          />
        )}

      <ListSpinner loading={isFetchingNextPage} observerRef={observerRef} />
      {status === QueryStatus.PENDING && <AdminSpinner />}
    </>
  );
};
